// Shows error messages for high to obese BMI.
export const hideNewAnswers = (hideAnswers, answers) => {
  if (!answers.length > 0 || hideAnswers === "false") {
    return answers;
  }

  const newAnswers = answers.filter(answer => !answer?.tags.includes("new"));

  return newAnswers;
};
